import { createSlice } from "@reduxjs/toolkit";
import { getSubsidy } from "../reduxApi/DmsReduxApi";

const subsidySlice = createSlice({
    name: 'subsidy',
    initialState: {
    status: 'idel',
    subsidy: [],
    },
    reducers: {
        
        deleteSubsidyAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.attachments.findIndex((item) => item.subsidy.ROWID === id);
                if (index !== -1) {
                    state.subsidy.splice(index, 1);
                }
            });
        },     
        updateSubsidyAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.subsidy.findIndex((item) => item.attachments.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.subsidy.splice(index, 1, { subsidy: action.payload })
            }
        },
        addSubsidyAction: (state, action) => {
            // console.log("Adding client:", action.payload); 
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.subsidy.unshift({subsidy:temp});
          }
    },
        extraReducers: (builder) => {
            builder
                .addCase(getSubsidy.pending, (state) => {
                    state.status = 'pending';
                })
                .addCase(getSubsidy.fulfilled, (state, action) => {
                    state.status = 'fulfilled';
                    console.log("Subsidy data:", action.payload.data.response); // Optional debugging

                    state.subsidy = action.payload.data.response; 
                })
               
        }
        
})
export const { deletesubsidyAction, updatesubsidyAction, addsubsidyAction } = subsidySlice.actions
export default subsidySlice.reducer